import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const StatusCardsContainer = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  
  @media (max-width: 900px) {
    gap: 12px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`

export const StatusCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 12px;
  background-color: ${colors.white};
  border: 1px solid ${colors.gray300};
  color: ${colors.gray900};
  text-align: left;
  flex: 1;
  min-width: 0;
  
  @media (max-width: 1024px) {
    padding: 12px 16px;
    gap: 12px;
  }
  
  @media (max-width: 900px) {
    padding: 8px 12px;
    gap: 8px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 16px 20px;
    gap: 16px;
    min-width: unset;
  }
`

export const StatusIcon = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: ${colors.white};
`

export const StatusNumber = styled.div`
  font-size: 36px;
  font-weight: 400;
  
  @media (max-width: 1024px) {
    font-size: 28px;
  }
  
  @media (max-width: 900px) {
    font-size: 22px;
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`

export const StatusLabel = styled.div`
  font-size: .875rem;
  line-height: 1.4;
  color: ${colors.gray600};
  
  @media (max-width: 1024px) {
    font-size: 0.75rem;
  }
  
  @media (max-width: 900px) {
    font-size: 0.7rem;
    line-height: 1.3;
  }
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    line-height: 1.4;
  }
`

export const IconArea = styled.div<{ bg: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  background-color: ${({ bg }) => bg};
  flex-shrink: 0;
  
  @media (max-width: 1024px) {
    width: 36px;
    height: 36px;
  }
  
  @media (max-width: 900px) {
    width: 32px;
    height: 32px;
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`

export const CardContent = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
